import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Spin, Tooltip, Typography } from "antd";
import {
  useAccounts,
  useOptionsBanks,
} from "hook/finance/withdraw/useWithdraw";
import React from "react";
import { RiDeleteBack2Line } from "react-icons/ri";
import { useSelector } from "react-redux";
import { defaultBankAllSelector } from "store/bailiff/default/bank/default_bank.selector";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const CardAccount = ({ data, index }) => {
  // -------------------------- VAR -----------------------------
  const { loading, showConfirmDeleteAccount, handleSelect } = useAccounts();
  const { banks: options } = useOptionsBanks();
  const form = Form?.useFormInstance();
  //   const code = Form?.useWatch("code", form) || null;
  const accountName = data?.accountName || null;
  const accountNumber = data?.accountNumber || null;
  const codeS = data?.code;
  const id = data?.id;

  const selected = options?.find((o) => o?.code === codeS);
  const logo = selected?.logo;
  const name = selected?.name;

  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const icon = loading ? (
    <Spin indicator={<LoadingOutlined />} size={20} />
  ) : (
    <RiDeleteBack2Line size={20} />
  );
  const banks = useSelector(defaultBankAllSelector);
  const isLast = index === banks?.length - 1;
  const border = isLast
    ? {}
    : {
        borderBottom: "1px solid #e5e5e5",
      };
  // -------------------------- FUNCTION ------------------------
  const chooseAccount = () => {
    if (!accountName || !accountNumber || !codeS) return;
    const data = { accountName, accountNumber, code: codeS };
    handleSelect(form, data);
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderLogo = () => {
    return (
      <img
        src={logo}
        style={{ width: 80, height: "auto", borderRadius: "50%" }}
        alt="logo-bank"
      />
    );
  };

  const renderRemove = () => {
    return (
      <Tooltip title="Xoá khỏi danh bạ">
        <Button
          onClick={() => showConfirmDeleteAccount(id)}
          icon={icon}
          type="text"
          shape="circle"
          danger
          variant="filled"
        />
      </Tooltip>
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <div
      style={{
        display: "flex",
        gap: 10,
        cursor: "pointer",
        alignItems: "center",
        paddingBottom: 10,
        ...border,
      }}
    >
      <div
        onClick={chooseAccount}
        style={{ display: "flex", justifyContent: "center", flex: 0.2 }}
      >
        <div>{renderLogo()}</div>
      </div>
      <div
        onClick={chooseAccount}
        style={{ display: "flex", flex: 0.75, flexDirection: "column", gap: 6 }}
      >
        <div style={{ fontSize: 16, fontWeight: 500 }}>{accountName}</div>
        <div style={{ fontSize: 16, fontWeight: 500 }}>{accountNumber}</div>
        <Typography.Text type="secondary">{name}</Typography.Text>
      </div>
      <div style={{ display: "flex", justifyContent: "center", flex: 0.15 }}>
        <div>{renderRemove()}</div>
      </div>
    </div>
  );
};
export default CardAccount;
